<script lang="ts">
    import type { Snippet } from 'svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import PureProductTile from '@tilelist/components/product-tile-item/PureProductTile.svelte';
    import PureProductTileE3933 from '@tilelist/layouts/experiments/e3933/product-tile-item/PureProductTile.svelte';

    type Props = {
        children: Snippet;
        articleNumber?: string;
        productId: string;
        variationId?: string;
        listPosition: number;
        localListPosition: number;
        origin?: string;
        [key: `data-${string}`]: string | undefined;
    };

    let { children, ...rest }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

{#if visualRefreshActive}
    <PureProductTileE3933 {...rest}>{@render children()}</PureProductTileE3933>
{:else}
    <PureProductTile {...rest}>{@render children()}</PureProductTile>
{/if}
